<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<h1 class="P_Heading_1" id="auto_bookmark_toc_4"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em;">ONCE AGAIN</span> I have to give a shout-out to my sisters in words. Anne Turner, Aliyah Burke, and Carmen Cook, thank you for standing by me through all the laughter and tears bringing this story to life.</p>
<p class="P_Normal">Neva West, for always being an inspiration.</p>
<p class="P_Normal">To my husband, David, thank you for always believing in my dreams and understanding when I talk about my characters as if they are actual people. I am so grateful to have you by my side on this journey. Jackie and Satchel, your words of encouragement and support mean the world to me and it is such a joy to be your mom. Thank you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0004.vue?14aa2622